import React from "react";

import "./Popup.scss";
const Popup = () => {
  return (
    <section className="popup" id="popup">
      <div className="popup-content">
        {/* <div className="popup-left">
          <img
            className="popup-img"
            src="img/swiss-italy-train.ngsversion.1512133001257.adapt.1900.1.jpg"
            alt="train photo"
          />
          <img
            className="popup-img"
            src="img/zermatt-matterhorn-switzerland-shutterstock_1298208013_44fea015e5_alps.jpg"
            alt="zermatt-matterhorn-switzerland photo"
          />
        </div> */}
        <div className="popup-main">
          <a href="#sectionm-tours" className="popup-close">
            &times;
          </a>
          <h2 className="heading-secondary">thank you for your interest</h2>
          <h3 className="heading-tertiary">
            important &ndash; this is a demo!
            <p className="popup-text">
              this is a CSR website that i've built using react js to show my
              sass/scss skills (design rights belong to jonas schmedtmann ) and
              my interest in awesome country of switzerland , i have had so many
              more plans like to have some tables that fetch their data from a
              live service API, but alas i couldn't find any of them that was
              either live or free, thank you for checking sections out but due
              to lack of funding and future proof-ity of this website (im
              currently not a citizen of switzerland) what you see is what you
              get, again thank you for your visit and i hope we can work
              together in the near future , you can find my contacts in footer
              and navigation section. <br />
              with love AmirReza Tamandni &#10084;
            </p>
          </h3>
        </div>
      </div>
    </section>
  );
};

export default Popup;
